import { type ComponentPropsWithoutRef, type ElementRef, forwardRef, useId } from 'react';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import clsx from 'clsx';

import { Label } from '../Label';

import styles from './styles/RadioGroup.module.scss';

const RadioGroup = forwardRef<
  ElementRef<typeof RadioGroupPrimitive.Root>,
  ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Root
      className={clsx(styles.radioGroupRoot, className)}
      data-cxy-name="radio-group"
      {...props}
      ref={ref}
    />
  );
});
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

const RadioGroupItem = forwardRef<
  ElementRef<typeof RadioGroupPrimitive.Item>,
  ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ children, className, ...props }, ref) => {
  const id = useId();

  return (
    <Label className={clsx(styles.label, { [styles.checked]: props.checked })} id={id}>
      <RadioGroupPrimitive.Item
        aria-labelledby={id}
        className={clsx(styles.radioGroupItem, className)}
        ref={ref}
        {...props}
      >
        <RadioGroupPrimitive.Indicator className={styles.radioGroupIndicator} />
      </RadioGroupPrimitive.Item>
      {children}
    </Label>
  );
});
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

export { RadioGroup, RadioGroupItem };
